import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import { toast } from "react-toastify";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import useCompressImageConfig from "../../../components/CommonApis/Compressimageapi";
import { getItemToken } from "../../../Utils/localStorageUtils";

import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from "../../../CustomFields/saveCustomFieldsStrict";
function SeriesGenreAddUpdate({ isModal = false, onSuccess, forceCreate = false }) {
    const { fetchRequest, globalImageUplaodAPI } = useMyContext()
    const { compressResolutionFormat } = useCompressImageConfig();

    const { id } = useParams()
    const isEditing = !!id && !forceCreate
    const combinedRef = useRef({});
    const navigate = useNavigate()
    const headers = getItemToken('access_token')

    const baseURL = process.env.REACT_APP_Baseurl
    const storeApi = `${baseURL}/admin/series/category/store`
    const labelApi = `${baseURL}/admin/Label-Management/list-source`
    const createApi = `${baseURL}/admin/series/category/create`
    const editApi = `${baseURL}/admin/series/category/edit`
    const imageApi = globalImageUplaodAPI()
    const updateApi = `${baseURL}/admin/series/category/update`

    const [formData, setFormData] = useState({
        name: '',
        slug: '',
        parent_id: '',
        home_genre: '',
        in_home: 0,
        in_menu: 0,
        footer: 0,
        banner: 0,
        parent_category: 1
    })
    const [formDataError, setFormDataError] = useState({})
    const [defaultOption, setDefaultOption] = useState()
    const [coverImageFile, setCoverImageFile] = useState(null);
    const [bannerImageFile, setBannerImageFile] = useState(null);
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [labelDisplay, setLabelDisplay] = useState([]);
    const [customFieldValues, setCustomFieldValues] = useState({});
    const validateImageRatio = (file, expectedRatio, expectedWidth, expectedHeight) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const ratio = width / height;
                const expectedRatioPrecision = 0.01;
                const ratioMatch = Math.abs(ratio - expectedRatio) < expectedRatioPrecision;
                const dimensionMatch = (width === expectedWidth && height === expectedHeight);
                if (ratioMatch || dimensionMatch) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
            img.onerror = () => {
                reject(new Error('Error loading image'));
            };
        });
    };

    // const handleFileChange = async (event) => {
    //     const { files, name, value, accept } = event.target
    //     setFormDataError((prev) => ({
    //         ...prev,
    //         [name]: "",
    //     }));
    //     const checkSize = compressResolutionFormat?.series === 1
    //     const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    //     if (files?.length > 0) {
    //         const newFile = files[0];
    //         const reader = new FileReader();
    //         const readFile = (file) => {
    //             return new Promise((resolve, reject) => {
    //                 const reader = new FileReader();
    //                 reader.onload = () => resolve(reader.result);
    //                 reader.onerror = (error) => reject(error);
    //                 reader.readAsDataURL(file);
    //             });
    //         };
    //         const fileContent = await readFile(newFile);
    //         const isValidSizeEqual = await validateImageRatio(newFile, 1 / 1, 1080, 1080);
    //         const isValidSizeHorizontal = await validateImageRatio(newFile, 16 / 9, 1280, 720);

    //         if (name == "image") {
    //             setCoverImageFile(newFile);
    //             if (!allowedTypes.includes(files[0]?.type)) {
    //                 setFormDataError((prev) => ({
    //                     ...prev,
    //                     [name]: "Only JPG, JPEG, and PNG files are allowed.",
    //                 }));

    //                 combinedRef.current['image'].focus()
    //                 return;
    //             }
    //             if (checkSize && !isValidSizeEqual) {
    //                 setFormDataError((prev) => ({
    //                     ...prev,
    //                     [name]: "Image must be in 1:1 Ratio or 1080px (x) 1080px",
    //                 }));
    //                 combinedRef.current['image'].focus()
    //                 return;
    //             }
    //         } if (name == "banner_image") {
    //             setBannerImageFile(newFile);
    //             if (!allowedTypes.includes(files[0]?.type)) {
    //                 setFormDataError((prev) => ({
    //                     ...prev,
    //                     [name]: "Only JPG, JPEG, and PNG files are allowed.",
    //                 }));

    //                 combinedRef.current['banner_image'].focus()
    //                 return;
    //             }
    //             if (checkSize && !isValidSizeHorizontal) {
    //                 setFormDataError((prev) => ({
    //                     ...prev,
    //                     [name]: "Image must be in 16:9 Ratio or 1280x720px.",
    //                 }));
    //                 combinedRef.current['banner_image'].focus()
    //                 return;
    //             }
    //         }
    //     }
    // }
    const handleFileChange = async (event) => {
        const { files, name } = event.target;

        // Clear previous error
        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));

        // Allowed image types
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

        const checkSize = compressResolutionFormat?.series === 1;

        if (files?.length > 0) {
            const newFile = files[0];

            // ✅ Block non-image file types early
            if (!allowedTypes.includes(newFile.type)) {
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: "Only JPG, JPEG, and PNG files are allowed.",
                }));
                combinedRef.current?.[name]?.focus();
                return;
            }

            // ✅ Only read image file now that type is verified
            const readFile = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });
            };

            try {
                const fileContent = await readFile(newFile);

                if (name === "image") {
                    setCoverImageFile(newFile);

                    if (checkSize) {
                        const isValidSizeEqual = await validateImageRatio(newFile, 1 / 1, 1080, 1080);
                        if (!isValidSizeEqual) {
                            setFormDataError((prev) => ({
                                ...prev,
                                [name]: "Image must be in 1:1 Ratio or 1080x1080px.",
                            }));
                            combinedRef.current?.[name]?.focus();
                            return;
                        }
                    }

                } else if (name === "banner_image") {
                    setBannerImageFile(newFile);

                    if (checkSize) {
                        const isValidSizeHorizontal = await validateImageRatio(newFile, 16 / 9, 1280, 720);
                        if (!isValidSizeHorizontal) {
                            setFormDataError((prev) => ({
                                ...prev,
                                [name]: "Image must be in 16:9 Ratio or 1280x720px.",
                            }));
                            combinedRef.current?.[name]?.focus();
                            return;
                        }
                    }
                }

            } catch (error) {
                console.error("File reading failed:", error);
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: "Failed to read the file. Please try again.",
                }));
            }
        }
    };

    const handleAdd = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["name", "slug", "parent_id", "home_genre", "in_home", "in_menu", "footer", "banner"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            if (formData?.parent_category === 1) {
                formDataAdd.parent_id = null;
            }
            const response = await fetchRequest({
                method: 'POST',
                url: `${storeApi}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                if (coverImageFile || bannerImageFile) {
                    await handleImageUpload(result?.id)
                }
                setShowOverlay(false);
                toast.success(result?.message)
                if (typeof onSuccess === 'function') {
                    onSuccess(result?.id, formData?.name);
                } else {
                    navigate("/series-category");
                }
            }
            else {
                setShowOverlay(false);
                toast.error(result?.message)
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
            console.error("error", err)
        }
    }

    const handleImageUpload = async (id) => {
        try {
            const formDataAdd = new FormData();
            const imageFields = [];
            formDataAdd.append('image', coverImageFile);
            formDataAdd.append('banner_image', bannerImageFile);
            imageFields.push('image', 'banner_image');
            formDataAdd.append('modelName', 'SeriesGenre');
            formDataAdd.append('id', id);
            imageFields.forEach((field) => {
                formDataAdd.append('imageFields[]', field);
            });

            const response = await fetchRequest({
                method: 'POST',
                url: `${imageApi}`,
                params: {},
                data: formDataAdd,
            })
            if (response?.status) {
                setCoverImageFile(null)
                setBannerImageFile(null)
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err?.message)
        }
    }

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            setFormData((prev) => ({
                ...prev,
                [name]: checked ? 1 : 0,
            }));
        }
        else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }
    };

    const handleInputKeyDowntitle = (event) => {
        if (event.key === "Enter" || event.key === "Tab") {
            if (formData?.slug) {
                return
            }
            generateSlug(formData?.name);
        }
    };

    const handleBlurtitle = () => {
        if (formData?.slug) {
            return
        }
        generateSlug(formData?.name);
    };

    const generateSlug = async (name) => {
        const slug = await slugGenerator(name)
        setFormData((prev) => ({
            ...prev,
            'slug': slug,
        }));
    };

    const handleBlurTitleEdit = () => {
        generateSlug(formData?.slug);
    };

    const formValidation = () => {
        let formIsValid = true;
        if (!formData?.name) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                name: "Title cannot be empty.",
            }));
            combinedRef.current['name'].focus()
            formIsValid = false;
        } else if (!formData?.slug) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                slug: "Slug cannot be empty.",
            }));
            combinedRef.current['slug'].focus()
            formIsValid = false;
        }
        if (formDataError?.image) {
            combinedRef.current['image'].focus()
            formIsValid = false;
        }
        if (formDataError?.banner_image) {
            combinedRef.current['banner_image'].focus()
            formIsValid = false;
        }
        if (compressResolutionFormat?.series === 1) {
            if ((id && !formData?.image_url) || (!id && !coverImageFile)) {
                setFormDataError(prev => ({
                    ...prev,
                    image_url: "Please provide cover image"
                }));
                combinedRef.current['image'].focus();
                formIsValid = false;
            }
            if ((id && !formData?.banner_image_url) || (!id && !bannerImageFile)) {
                setFormDataError((prev) => ({
                    ...prev,
                    banner_image_url: "Please provide banner image"

                }))
                combinedRef.current['banner_image'].focus()
                formIsValid = false;
            }
        }
        if (!formData?.name || formData?.name.trim().length < 3 || formData?.name.trim().length > 100) {
            toast.error("Name must be between 3 and 100 characters.");
            formIsValid = false;
        }

        if (!formData?.slug || formData?.slug.trim().length < 3 || formData?.slug.trim().length > 100) {
            toast.error("Slug must be between 3 and 100 characters.");
            formIsValid = false;
        }
        return formIsValid;
    }

    const handleStore = () => {
        if (formValidation()) {
            if (!id) {
                handleAdd()
            }
            else {
                handleUpdate()
            }
        }
    }

    const handleUpdate = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["name", "slug", "parent_id", "home_genre", "in_home", "in_menu", "footer", "banner"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            if (formData?.parent_category === 1) {
                formDataAdd.parent_id = null;
            }
            const response = await fetchRequest({
                method: 'POST',
                url: `${updateApi}/${id}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                // save custom field values (strict)
                try {
                    await saveCustomFieldsStrict({ baseURL, headers, entityType: 'series_genre', entityId: id, values: customFieldValues });
                } catch (e) {
                    toast.error(e?.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                }
                if (coverImageFile || bannerImageFile) {
                    await handleImageUpload(result?.id)
                }
                setShowOverlay(false);
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)
            }
            else {
                setShowOverlay(false);
                toast.error(result?.message)
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
            console.error("error", err)
        }
    }

    const handleClearSelectFile = (value) => {
        if (value == 'image') {
            setCoverImageFile(null)
        }
        else {
            setBannerImageFile(null)
        }
    }

    const fetchData = async () => {
        const response = await fetchRequest({
            method: 'GET',
            url: `${createApi}`,
            params: {},
            data: {}
        }).then((response) => {
            var result = response?.data;
            setDefaultOption(result)
        }).catch((error) => toast.error(error?.response?.data?.message || error?.message));
    }

    function flattenCategories(list, level = 0, result = []) {
        (list || []).forEach(item => {
            const indent = '\u00A0\u00A0\u00A0\u00A0'.repeat(level);
            const prefix = level ? '• ' : '';
            result.push({ id: item.id, label: `${indent}${prefix}${item.name}` });
            if (item.sub_category?.length) {
                flattenCategories(item.sub_category, level + 1, result);
            }
        });
        return result;
    }

    const fetchEditData = async () => {
        const response = await fetchRequest({
            method: 'GET',
            url: `${editApi}/${id}`,
            params: {},
            data: {}
        }).then((response) => {
            var result = response?.data;
            setFormData({
                ...result,
                parent_category: result?.parent_id ? 0 : 1
            })

        }).catch((error) => toast.error(error?.response?.data?.message || error?.message));
    }

    const labeFetch = async () => {
        try {
            const response = await fetchRequest({
                method: 'GET',
                url: `${labelApi}`,
                params: { source: "series-Category" },
                data: {}
            });
            setLabelDisplay(response?.label_management || []);
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message);
        }
    }

    useEffect(async () => {
        await labeFetch()
        await fetchData()
    }, []);

    useEffect(async () => {
        if (id && !forceCreate) {
            await fetchEditData()
        }
    }, [withOutRefresh, id, forceCreate]);
    return (
        <div className="pb-5">
            {showOverlay && (<Response_Processing />)}
            {!isModal && <AdminBackNavigation path={`${"/series-category"}`} text="Back" />}
            {!isModal && <AdminSaveHeader buttonId="series-category-submit-up" heading={!isEditing ? labelDisplay?.[0]?.title : labelDisplay?.[13]?.title} saveText={!isEditing ? labelDisplay?.[12]?.title : labelDisplay?.[12]?.title} saveMethod={handleStore} />}
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={!isEditing ? labelDisplay?.[1]?.title : formData?.name} />
                        <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
                        <AdminCustomInput id="series-category-name" type="text" name="name" value={formData?.name} onChange={handleInput} placeHolder={"Title"} ref={(el) => (combinedRef.current.name = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.name} />
                        <MessageLabel text={labelDisplay?.[3]?.title} />
                        <AdminCustomInput id="series-category-slug" type="text" name="slug" value={formData?.slug} ref={(el) => (combinedRef.current.slug = el)} onChange={handleInput} onBlur={() => handleBlurTitleEdit()} placeHolder={"Slug"} error={formDataError?.slug} />
                        <FormContainer>
                            <div className="col-7 col-md-7 pe-2">
                                <MessageLabel text={"Make as Parent Category"} />
                            </div>
                            <div className="col-5 col-md-5 ps-2 text-end">
                                <AdminSwitch id="series-genre-parent-category" name="parent_category" checked={Number(formData?.parent_category) === 1} onChange={handleInput} />
                            </div>
                        </FormContainer>

                        {Number(formData?.parent_category) === 0 && <>
                            <MessageLabel text={"Select Parent Category"} />
                            <select
                                name="parent_id"
                                value={formData?.parent_id || ""}
                                onChange={handleInput}
                                className="custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3"
                            >
                                <option value="">Choose a category</option>
                                {flattenCategories(defaultOption || []).map(opt => (
                                    <option className="theme-bg-color theme-text-color" key={opt.id} value={opt.id}>{opt.label}</option>
                                ))}
                            </select>
                            {formDataError?.parent_id && (
                                <p className="text-danger">{formDataError.parent_id}</p>
                            )}
                        </>}

                        <div className="card p-3 mt-3">
                            {/* <MessageHeading text="Additional Fields" /> */}
                            {/* Custom fields  */}
                            <FieldRenderer2
                                pageIdentifier={id ? "series_genre.edit" : "series_genre.create"}
                                entityType="series_genre"
                                entityId={id}
                                text="Additional Fields"
                            />
                            <FieldRenderer
                                pageIdentifier={id ? "series_genre.edit" : "series_genre.create"}
                                entityType="series_genre"
                                entityId={id}
                                onChange={setCustomFieldValues}
                            />
                        </div>
                    </Wrapper>
                </LeftWrapper>

                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[9]?.title} />
                        <MessageLabel text={labelDisplay?.[10]?.title} className="mandatorySimple mb-1 m-0" />
                        <p className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Select the image(  1:1 Ratio or 1080px (x) 1080px )</p>
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={coverImageFile}
                            uploadedImage={formData?.image_url}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.image = el)}
                            name="image"
                            id={isEditing ? id : undefined}
                            error={formDataError?.image}
                            idAttribute="series-category-image" />

                        <MessageLabel text={labelDisplay?.[11]?.title} className="mandatorySimple" />
                        <p className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Select the image( 16:9 Ratio or 1280x720px )</p>

                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={bannerImageFile}
                            uploadedImage={formData?.banner_image_url}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.banner_image = el)}
                            name="banner_image"
                            id={isEditing ? id : undefined}
                            error={formDataError?.banner_image}
                            idAttribute="series-category-banner-image" />
                    </Wrapper>

                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[5]?.title} />
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={labelDisplay?.[6]?.title} className="" />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch id="series-category-in-menu" name={"in_menu"} checked={formData?.in_menu == 1} onChange={handleInput} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={labelDisplay?.[7]?.title} className="" />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch id="series-category-in-home" name={"in_home"} checked={formData?.in_home == 1} onChange={handleInput} />
                            </div>
                        </div>
                        {/* <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={labelDisplay?.[8]?.title} className="" />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch id="series-category-footer" name={"footer"} checked={formData?.footer == 1} onChange={handleInput} />
                            </div>
                        </div> */}
                    </Wrapper>
                </RightWrapper>
                <AdminCustomButton id="series-category-submit-down" className='px-3 py-1 m-0 ms-auto' saveMethod={handleStore} saveText={!isEditing ? labelDisplay?.[12]?.title : labelDisplay?.[12]?.title} />
            </FormContainer>
        </div>
    );
}

export default SeriesGenreAddUpdate;